import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import CreateAttributeList, { attributeTypes} from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AttributeDefinition, AttributeInputType, GetWBComponentByTypename } from "../Data/WBData";
import LayoutNode, { getNodeComponentAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ResizeableType, WBComponent} from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import RenderNavigationBar from "vagaro-website-rendering/src/components/ComponentRenders/RenderNavigationBar";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
import { PageData } from "../Data/SiteData";
import WebDesigner from "../WebDesigner";
import { AlignBottom, AlignCenterVertical, AlignTop } from "../Icons/AlignmentIcons";

export default class NavigationBar extends WBComponent{

    constructor(){
        super();
        this.typename =  wBComponentTypeNames.navigationBar;
        this.isStatic = true;
        this.displayName = "Navigation Bar";
        this.resizeType = ResizeableType.VerticalOnly;

        this.primaryEditAttributes = ["navLayout","positionType","navBreakPoint","nav-vertical-align","logo","logoSize","mobilelogo","mobilelogoSize","buttonName","link","navSpacing"];
        this.editList = ["dropdownBg","dropMenuBg","navHoverBG","navHoverText","underLineColor", "savedLink","dropMenuBg","alignItems","bLogoTest","link",...this.primaryEditAttributes,...CreateAttributeList(false,true,true,true,false,false).filter((item)=>item!="backgroundColor"&&item!="width"),"padding",attributeTypes.boxShadow];

        this.cssDefinitions= [

            new NodeCSSClassDefinition(".main-navigation ul li, .mobile-navigation-content",
            [
                {key:"dropdownBg",cssProperty:"background-color",default:"var(--default-bg-color)"},


             ],true),
             new NodeCSSClassDefinition(".pofile-drop",
             [
                 {key:"dropdownBg",cssProperty:"background-color",default:"var(--default-bg-color)"},


              ],true),
             new NodeCSSClassDefinition("",
             [
                 {key:"dropdownBg",cssProperty:"background-color",default:"var(--default-bg-color)"},


              ]),
              new NodeCSSClassDefinition(".main-navigation ul li",
              [
                  {key:"dropMenuBg",cssProperty:"background-color",default:""},


               ]),
               new NodeCSSClassDefinition(".mobile-navigation-content",
               [
                   {key:"dropMenuBg",cssProperty:"background-color",default:" "},


                ]),


            new NodeCSSClassDefinition(".navigation-item:hover",
            [
                {key:"navHoverBG",cssProperty:"background-color",default:""},

                {key:"navHoverText",cssProperty:"color",default:""},

                {key:"underLineColor",cssProperty:"border-color",default:""},


             ],true),
             new NodeCSSClassDefinition(".navigation-item.active", // selected page
             [
                 {key:"navHoverBG",cssProperty:"background-color",default:""},

                 {key:"navHoverText",cssProperty:"color",default:""},

                 {key:"underLineColor",cssProperty:"border-color",default:""},


              ],true),



             new NodeCSSClassDefinition(".main-navigation",
             [
                 {key:"navSpacing",cssProperty:"gap",default:""},



              ],true),
        ]

        this.colorFields = ["color","dropdownBg","dropMenuBg","navHoverBG","navHoverText","underLineColor"];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
    }


    getComponentSpecificAttributeDefinitions() {
        let btnName =       new AttributeDefinition(
            "buttonName",
            "Optional Button",
            "",
            AttributeInputType.InputFiled
          );


          btnName.placeHolder = "Book Now..."
        return [ new AttributeDefinition("positionType","Position","",AttributeInputType.ButtonField,
                [
                    {label:"Normal",value:""},
                    {label: "Stick to Top",value:"fixed-above"},

                ]),
                btnName,
                new AttributeDefinition("navLayout","Layout","",AttributeInputType.SelectField,
                [
                    {label:"Centered",value:"1"},

                    {label: "Split",value:"3"},

                    {label: "Left",value:"5"},

                    {label: "Right",value:"7"},

                    {label: "Tall",value:"9"},
                ]),
                new AttributeDefinition("nav-vertical-align","Vertical Align","",AttributeInputType.ButtonField,
[
  {label:"Auto",value:""},
  {label:<AlignTop/>,value:"align-start",toolTip:"Align Top"},
  {label:<AlignCenterVertical/>,value:"align-center",toolTip:"Align Center"},
  {label:<AlignBottom/>,value:"align-end",toolTip:"Align Bottom"},


]),
                new AttributeDefinition("dropdownBg","Background","",AttributeInputType.ColorField),
                new AttributeDefinition("dropMenuBg","Dropdown Background","",AttributeInputType.ColorField),
                new AttributeDefinition("navHoverBG","Highlight Background","",AttributeInputType.ColorField),
                new AttributeDefinition("logo","Logo Image","",AttributeInputType.ImageField),
                new AttributeDefinition("mobilelogo","Mobile Logo","",AttributeInputType.ImageField),
                new AttributeDefinition("navHoverText","Highlight Text","",AttributeInputType.ColorField),
                new AttributeDefinition("underLineColor","Highlight Underline","",AttributeInputType.ColorField),

                new AttributeDefinition("navSpacing","Spacing","",AttributeInputType.MeasurementField,
                [
                {label:"Auto",value:""},
                {label:"S",value:"4px"},
                {label:"M",value:"10px"},
                {label:"L",value:"24px"}

                ],{min:0,max:200,step:1,unit:"px"}),
                new AttributeDefinition("navBreakPoint","Collapse At","",AttributeInputType.ButtonField,
                [
                {label:"Auto",value:""},
                {label:<span className="font-small">Mobile</span>,value:"767px"},
                {label:<span className="font-small">Tablet</span>,value:"1200px"},


                ],{min:0,max:3000,step:1,unit:"px",default:1200}),

                new AttributeDefinition("logoSize","Logo Size","",AttributeInputType.MeasurementField,
                [
                {label:"Auto",value:""},
                {label:"S",value:"64px"},
                {label:"M",value:"128px"},
                {label:"L",value:"250px"}

                    ],{min:0,max:500,step:1,unit:"px"}),
                    new AttributeDefinition("mobilelogoSize","Mobile Logo Size","",AttributeInputType.MeasurementField,
                    [
                    {label:"Auto",value:""},
                    {label:"S",value:"48px"},
                    {label:"M",value:"72px"},
                    {label:"L",value:"128px"}

                        ],{min:0,max:500,step:1,unit:"px"}),
        ]

    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, "positionType", "fixed-above");
    }

    GetComponentGlobalCSS(node: LayoutNode, isEditor?: boolean,isLivePublish?:boolean): string {

        const breakPnt = getNodeComponentAttributeValue(node,"navBreakPoint","1200px");
        const hidePoint = parseInt(breakPnt.replace("px",""))+1+"px";

        const target = "@media";//(isLivePublish)?"@media":"@container";


        let collapse = (breakPnt=="767px")?".mobile-break":".tablet-break";


        let hidBreak = collapse==".mobile-break"?".screen-tablet":".screen-desktop"

        const safairiStyle = `
            .screen-desktop .mobile-navigation{
                display:none;
            }

            .screen-desktop  .mobile-navigation-menu{
                display:none;
            }


           ${hidBreak} .mobile-navigation{
                display:none;
            }

            ${hidBreak}  .mobile-navigation-menu{
                display:none;
            }



        ${collapse} .account-controls{
                right:42px !important;

                align-items:center !important;

            }
            ${collapse} .account-container{
                align-items:center !important;
            }
            ${collapse} .account-controls .v-login{
                display:none;
            }

            ${collapse} .full-screen-navigation{
                display:none;
            }


        ${collapse}  .cta-container{
            display: block;
        }



        `

        const screenStyle =  `



        ${target} (min-width: ${hidePoint}) {
            .mobile-navigation{
                display:none;
            }

            .mobile-navigation-menu{
                display:none;
            }

        }
        ${target}  (max-width: ${breakPnt}) {

            .account-controls{
                right:42px !important;

                align-items:center !important;

            }
            .account-container{
                align-items:center !important;
            }
            .account-controls .v-login{
                display:none;
            }

            .full-screen-navigation{
                display:none;
            }

            .cta-container{
                display: block;
            }
        }




    `;



        return super.GetComponentGlobalCSS(node,isEditor)+ (isLivePublish?screenStyle: safairiStyle);



    }

    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps): JSX.Element {


    //if(isEditor){
        let pages = [...userContext.pages].filter((val) => {  return (!val.isDisabled )});

        let hidden:PageData = {
            name: "hidden", url: "/", pageId: "link", isDisabled: true, isFolder: true, children: [],
            openGraphImageUrl: "",
            isLandingPage: false,
            isHidePage: true,
            isDuplicateAllLocationPage:false
        };

        let height = getNodeStyleAttributeValue(component,screenSize,attributeTypes.height,"");
        if(height.includes("%")){ // saftey check to prevent navbar from being set by perc
            setNodeStyleAttributeValue(component,screenSize,attributeTypes.height,"");
        }


        for(let i = 0;i<userContext.pages.length;i++){
            const pg = userContext.pages[i];
            if((pg.isDisabled || pg.isHidePage) && pg.children&&pg.children.length>0){

                    for(let ii = 0;ii<pg.children.length;ii++){
                        if(!pg.children[ii].isDisabled && !pg.children[ii].isHidePage){

                            let clone = {
                                ...pg.children[ii],

                            } as PageData;
                            clone.isDisabled = true;
                            hidden.children!.push(
                                clone
                            );
                        }
                    }
            }



        }

        if(hidden.children!.length>0){

            pages.push(hidden);
        }

        setNodeComponentAttributeValue(component, "pages", JSON.stringify(pages));



        const fixedClass = getNodeComponentAttributeValue(component,"positionType","");
        const comp = GetWBComponentByTypename(wBComponentTypeNames.navigationBar);



        return <>

        <div {...GetNodeDomAttributes("w-full v-navigation-bar  font-med font-bold "+fixedClass,component,screenSize,isEditor)}  {...GetNodeComponenentAttributeBinding(component, isEditor)}>

           {isEditor&& <style>
                {comp.GetComponentGlobalCSS(component,isEditor)}
            </style>}
            <RenderNavigationBar userContext={userContext} node={component}/>
        </div>
        </>
    }

}
